// @flow

import React, { Component, Children, type Node } from 'react';
import CookieBanner from 'client/components/banner/CookieBanner';
import HtmlHead from 'client/components/htmlHead';
import StrideHeaderWrapper from 'client/components/strideHeaderWrapper';
import 'client/styles/common.scss';
import { fetchHealthGuide } from '../actions/guide';

type Props = {
  children: Node,
};

class App extends Component<Props> {
  static fetchData({ dispatch }) {
    return dispatch(fetchHealthGuide());
  }

  render() {
    return (
      <StrideHeaderWrapper showPhone={false} noShadow>
        <div>
          <HtmlHead title="Stride Health - Health Insurance Guide" />
          {Children.only(this.props.children)}
          <CookieBanner />
        </div>
      </StrideHeaderWrapper>
    );
  }
}

export default App;
